import React from 'react';
import { GQLDimensions2D, GQLDimensions3D } from '@jewelutions/core-crm-server-api-client-domain';

interface IProps {
  dimensions2D?: GQLDimensions2D;
  dimensions3D?: GQLDimensions3D;
}

const Dimensions: React.FC<IProps> = ({ dimensions2D, dimensions3D }: IProps) => {
  return (
    <React.Fragment>
      {dimensions2D && (
        <React.Fragment>
          H:{dimensions2D!.height} mm x W:{dimensions2D!.width} mm
        </React.Fragment>
      )}
      {dimensions3D && (
        <React.Fragment>
          H:{dimensions3D!.height} mm x W:{dimensions3D!.width} mm x D:{dimensions3D!.depth} mm
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Dimensions;
